import apiRequest from "../../apiCall";

// get data
export function GetBlogApi(url) {
  return new Promise((resolve, reject) => {
    apiRequest("get", url, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// add data
export function PostBlogApi(formData) {
  return new Promise((resolve, reject) => {
    apiRequest("post", "blogs/addblog", formData, false, false)
      .then((res) => {
        sessionStorage.setItem("blogAPI", JSON.stringify(res));
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//update data
export function PutBlogApi(formData, urlid) {
  return new Promise((resolve, reject) => {
    apiRequest("post", urlid, formData, false, false)
      .then((res) => {
        sessionStorage.setItem("blogAPI", JSON.stringify(res));
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
//delete data
export function DeleteBlogApi(_id, formData) {
  return new Promise((resolve, reject) => {
    apiRequest("delete", `blogs/${_id}`, formData, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//get user blogs
export function GetUserBlogApi(url) {
  return new Promise((resolve, reject) => {
    apiRequest("get", url, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
